import React from 'react';

// Components
import WpDataTable, { SortDirection } from 'Wpds/components/table/WpDataTable';
import UserCell from './UserCell';

type Props = {
  workspaceActivity;
};

const ExecutiveWorkspaceActivity = ({ workspaceActivity }: Props) => {
  if (!workspaceActivity) return null;

  return (
    <WpDataTable
      columns={[
        {
          name: 'Name',
          initialSort: SortDirection.ASC,
          columnGroup: 'User',
          component: ({ row }) => UserCell(row),
        },
        { name: 'Department', selector: 'user_department', columnGroup: 'User' },
        { name: 'Role', selector: 'user_role', columnGroup: 'User' },
        { name: 'Open', selector: 'action_items_open', columnGroup: 'Action Items' },
        { name: 'Completed', selector: 'action_items_closed', columnGroup: 'Action Items' },
        { name: 'Overdue', selector: 'action_items_overdue', columnGroup: 'Action Items' },
        { name: 'Open', selector: 'discussion_topics_open', columnGroup: 'Discussion Topics' },
        { name: 'Closed', selector: 'discussion_topics_closed', columnGroup: 'Discussion Topics' },
      ]}
      rows={workspaceActivity}
    />
  );
};

export default ExecutiveWorkspaceActivity;
